export type Vec3 = readonly [number, number, number];

export interface Pose {
  pos: Vec3;
  rot: Vec3;
}

export interface MobileShots {
  hero: Pose;
  about: Pose;
  projects: Pose;
  contact: Pose;
  now: Pose;
}

export interface CameraTargets {
  default: Pose;
  about: Pose;
  projects: Pose;
  monitor: Pose;
  phone: Pose;
  plant: Pose;
  cube: Pose;
  mobileShots: MobileShots;
}

export const cameraTargets: CameraTargets = {
  default: { pos: [1.009, 0.5463, 0.4983], rot: [-0.8313, 0.9383, 0.724] },
  about: { pos: [0.12, 0.2, 0.55], rot: [-1.54, 0.13, 1.41] },
  projects: { pos: [1.0, 0.45, 0.01], rot: [0.05, 0.05, 0.0] },
  monitor: { pos: [0.15, 0.3, 0.05], rot: [0.0, 1.57, 0.0] },
  phone: { pos: [0.4, 0.3, 0.2], rot: [-0.3, 0.8, 0.1] },
  plant: { pos: [0.6, 0.4, 0.5], rot: [-0.2, 0.5, 0.1] },
  cube: { pos: [0.28, 0.22, 0.32], rot: [-1.0, 0.6, 0.4] },
  mobileShots: {
    hero: { pos: [1.009, 0.5463, 0.4983], rot: [-0.8313, 0.9383, 0.724] },
    about: { pos: [0.08, 0.2, 0.6], rot: [-1.56, 0.32, 1.57] },
    projects: { pos: [1.2, 0.6, 0.6], rot: [-0.6, 1.0, 0.55] },
    contact: { pos: [0.9, 0.45, 0.4], rot: [-0.6, 0.95, 0.5] },
    now: { pos: [0.6, 0.4, 0.5], rot: [-0.2, 0.5, 0.1] },
  },
};
